import React from 'react';
import { Spin } from 'antd';
import styles from './index.module.less';

const LoadingPage: React.FC = () => {
  return (
    <div className={styles.loadingPage}>
      <Spin size='large' />
    </div>
  );
};

export default LoadingPage;
